import { render, staticRenderFns } from "./no-room.vue?vue&type=template&id=219749fa&scoped=true&"
import script from "./no-room.vue?vue&type=script&lang=js&"
export * from "./no-room.vue?vue&type=script&lang=js&"
import style0 from "./no-room.vue?vue&type=style&index=0&id=219749fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219749fa",
  null
  
)

export default component.exports